import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Tabs, Tab, Typography } from '@material-ui/core';

import ModeradoIcon from './ModeradoIcon';
import ConservadorIcon from './ConservadorIcon';
import AventureroIcon from './AventureroIcon';

const StyledTab = withStyles({
  root: {
    textTransform: 'none',
    fontSize: '22px',
    outline: 'none',
    maxWidth: 'unset',
  },
  selected: {
    '&:hover': {
      color: '#00ab8a',
      opacity: 1,
    },
    '&$selected': {
      color: '#00ab8a',
      outline: 'none'
    },
    '&:active': {
      outline: 'none'
    },
    '&:focus': {
      outline: 'none'
    },
  },
})(Tab)

const StyledTabs = withStyles({
  indicator: {
    backgroundColor: '#00ab8a',
    outline: 'none'
  }
})(Tabs)

interface TabContainerProps {
  children?: React.ReactNode;
}

function TabContainer(props: TabContainerProps) {
  return (
    <Typography component="div">
      {props.children}
    </Typography>
  );
}

const InversionAMedida = () => {
  const [value, setValue] = useState(0);
  const [variant, setVariant] = useState('fullWidth');

  function handleChange(event: React.ChangeEvent<{}>, newValue: number) {
    setValue(newValue);
  }

  useEffect(() => {
    if (!matchMedia("(min-width: 420px)").matches) {
      setVariant('scrollable');
    } else {
      setVariant('fullWidth');
    }
  }, []);

  return (
    <div className="px-4">
      <StyledTabs value={value} indicatorColor="secondary" variant={variant as any} onChange={handleChange}>
        <StyledTab label="Inversión conservadora" />
        <StyledTab label="Inversión moderada" />
        <StyledTab label="Inversión aventurera" />
      </StyledTabs>
      {value === 0 && (
        <TabContainer>
          <div className="md:flex md:items-center md:justify-around pt-8">
            <div className="p-8 mb-4 md:w-1/3">
              <ConservadorIcon />
            </div>
            <div className="px-4 md:w-1/2">
              <h2 className="text-gray-700 text-4xl mb-4">Inversión conservadora</h2>
              <p className="text-gray-700 text-lg md:text-xl mb-4 leading-relaxed">
                Este tipo de inversionista se caracteriza por buscar inversiones de bajo riesgo,
                <strong> valorando la seguridad de su dinero</strong>. Por lo tanto, escoge instrumentos
                de inversión que le den certeza, aunque el rendimiento sea bajo.
              </p>
              <p className="text-gray-700 text-lg md:text-xl leading-relaxed">
                En Fondimex nos comprometemos a ofrecer inversiones de bajo riesgo con tasas superiores a las del mercado.
              </p>
            </div>
          </div>
        </TabContainer>
      )}
      {value === 1 && (
        <TabContainer>
          <div className="md:flex md:items-center md:justify-around pt-8">
            <div className="p-8 mb-4 md:w-1/3">
              <ModeradoIcon />
            </div>
            <div className="px-4 md:w-1/2">
              <h2 className="text-gray-700 text-4xl mb-4">Inversión moderada</h2>
              <p className="text-gray-700 text-lg md:text-xl leading-relaxed">
                Este tipo de inversionista se caracteriza por buscar inversiones con un poco de riesgo, buscando el <strong>balance entre certeza y rendimiento</strong>. Buscan instrumentos que ofrezcan un mayor rendimiento que las inversiones conservadoras, pero menor riesgo que las inversiones aventureras.
              </p>
              <p className="text-gray-700 mt-4 text-lg md:text-xl leading-relaxed">
                En Fondimex podrás encontrar una amplia gama de opciones de inversión, para diversificar tu portafolio, reducir el riesgo y maximizar el rendimiento.
              </p>
            </div>
          </div>
        </TabContainer>
      )}
      {value === 2 && (
        <TabContainer>
          <div className="md:flex md:items-center md:justify-around pt-8">
            <div className="p-8 mb-4 md:w-1/3">
              <AventureroIcon />
            </div>
            <div className="px-4 md:w-1/2">
              <h2 className="text-gray-700 text-4xl mb-4">Inversión aventurera</h2>
              <p className="text-gray-700 text-lg md:text-xl leading-relaxed">
                Este tipo de inversionista se caracteriza por buscar inversiones que le generen <strong>altos rendimientos.</strong> Es consciente que a mayor riesgo, mayor rendimiento. 
              </p>
              <p className="text-gray-700 text-lg mt-4 md:text-xl leading-relaxed">
                En Fondimex nos comprometemos a ofrecer altos rendimientos con un riesgo menor al del mercado.
              </p>
            </div>
          </div>
        </TabContainer>
      )}
    </div>
  )
}

export default InversionAMedida;
